export const Api = {
    getBaseUrl,
    getOptions
};

function getBaseUrl() {
    return process.env.REACT_APP_API_URL + '/rest/customer/v1/';
}

function getOptions(method = 'GET', body = {}, signal = null) {
    let options = {
        method: method,
        headers: getHeaders()
    };

    if (method !== 'GET' && Object.getOwnPropertyNames(body).length !== 0) {
        options['body'] = JSON.stringify(body);
    }

    if (signal !== null) {
        options['signal'] = signal;
    }

    return options;
}

function getHeaders()
{
    if (localStorage.getItem('token') === null) {
        return new Headers({
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        });
    } else {
        return new Headers({
            'X-Auth-Token' : localStorage.getItem('token'),
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        });
    }
}
